export default "__VITE_ASSET__09768dd2__"